import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "library-edit-bar level" }
const _hoisted_2 = { class: "level-left" }
const _hoisted_3 = { class: "has-text-weight-bold pr-15" }
const _hoisted_4 = { class: "level-right" }
const _hoisted_5 = ["disabled"]

import VglistUtils from "../utils";
import Turbolinks from "turbolinks";
import NumberField from "./fields/number-field.vue";
import StaticSingleSelect from "./fields/static-single-select.vue";
import { computed, reactive } from "vue";

interface Props {
  gamePurchases: any[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'library-edit-bar',
  props: {
    gamePurchases: {}
  },
  emits: ["closeEditBar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Reactive data
const updateData = reactive({
  ids: [] as number[],
  completion_status: null as any,
  rating: undefined as number | string | undefined
});

// Methods
function closeEditBar() {
  emit("closeEditBar");
}

function updateGames(): void {
  // Reset the array to the currently-selected gamePurchases.
  updateData.ids = props.gamePurchases.map((gp) => gp.id);

  if (updateData.rating === undefined || updateData.rating === null) {
    delete (updateData as any).rating;
  }

  // Clone the object before we mess with the values.
  // This prevents the values in the edit bar from changing when these
  // values are changed.
  let updateDataCopy = { ...updateData };

  if (updateDataCopy.completion_status !== null) {
    (updateDataCopy as any).completion_status = updateDataCopy.completion_status.value;
  }

  VglistUtils.rawAuthenticatedFetch(
    "/game_purchases/bulk_update.json",
    "POST",
    JSON.stringify(updateDataCopy)
  ).then((response) => {
    if (response.ok) {
      // Redirects to self.
      Turbolinks.visit(window.location.href);
    } else {
      console.log("Add error handling, doofus.");
    }
  });
}

// Computed properties
const selectedGamesString = computed((): string => {
  let gpLength = props.gamePurchases.length;
  return `${gpLength} game${gpLength > 1 ? "s" : ""} selected`;
});

const updateButtonActive = computed((): boolean => {
  if (Object.keys(updateData).length === 1) {
    return false;
  }

  let returnBool = false;

  // Check if rating or completion status have values.
  // If they do, return true. Otherwise, return false.
  (["rating", "completion_status"] as const).forEach((attribute) => {
    const value = updateData[attribute];
    if (value !== undefined && value !== "" && value !== null) {
      returnBool = true;
    }
  });

  return returnBool;
});

const FORMATTED_COMPLETION_STATUSES = [
  { label: "Unplayed", value: "unplayed" },
  { label: "In Progress", value: "in_progress" },
  { label: "Paused", value: "paused" },
  { label: "Dropped", value: "dropped" },
  { label: "Completed", value: "completed" },
  { label: "100% Completed", value: "fully_completed" },
  { label: "N/A", value: "not_applicable" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(selectedGamesString.value), 1),
      _createVNode(NumberField, {
        "form-class": '',
        "field-class": 'mb-0 mr-5',
        attribute: 'rating',
        placeholder: 'Rating (out of 100)',
        required: false,
        max: 100,
        width: '200px',
        modelValue: updateData.rating,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updateData.rating) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(StaticSingleSelect, {
        placeholder: 'Completion Status',
        "grandparent-class": 'field mb-0 mr-5',
        modelValue: updateData.completion_status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateData.completion_status) = $event)),
        options: FORMATTED_COMPLETION_STATUSES
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "button is-fullwidth-mobile mr-5 mr-0-mobile",
        onClick: closeEditBar
      }, " Cancel "),
      _createElementVNode("button", {
        class: "button is-fullwidth-mobile is-primary mr-5 mr-0-mobile",
        disabled: !updateButtonActive.value,
        onClick: updateGames
      }, " Update ", 8, _hoisted_5)
    ])
  ]))
}
}

})